<template>
<div style="padding:15px">
  <a-month-picker :allowClear="false" :disabledDate="disabledDate" :defaultValue="this.$moment(targetMonth, 'YYYY/MM')" @change="onTargetMonthChange" format="YYYY/MM" style="padding:15px 0px;width:50%;float:left" />

  <a-tooltip :defaultVisible="showTooltip" :visible="showTooltip">
    <template slot='title'>
        <p>{{editinfo.comment}}</p>
      </template>
    <a-tag :color="staColor" v-if="editinfo.status" style="margin:15px;padding:5px;height:100%">{{status}}</a-tag>
  </a-tooltip>

  <a-spin :spinning="isLoading">
    <a-form :form="form" @submit="onSubmit">
      <a-form-item label="稼働時間">
        <a-input v-decorator="['workinghours']" :disabled="disabledForm" />
      </a-form-item>
      <a-form-item>
        <a-button :disabled="disabledForm" style="width:100%;margin-top:15px" type="primary" html-type="submit">提出</a-button>
      </a-form-item>
    </a-form>
  </a-spin>
  <a-divider orientation="left">過去分</a-divider>
  <a-spin :spinning="isLoading">
    <a-list bordered :dataSource="listdata" size="small" itemLayout="vertical">
      <a-list-item slot="renderItem" slot-scope="item, index">
        <a-list-item-meta>
          <span slot="title">No.{{index}} {{item.targmonth}}</span>
          <span slot="description">
              {{item.statusex}}
          </span>
        </a-list-item-meta>
        {{item.workinghours}}h
      </a-list-item>
    </a-list>
  </a-spin>
</div>
</template>
<script>
export default {
  name: "WorkingHours",
  props: ["eid"],
  created() {
    this.targetMonth = this.$moment().format("YYYY/MM");
    console.log("targetMonth:" + this.targetMonth);
    this.form = this.$form.createForm(this, {
      onFieldsChange: (_, changedFields) => {
        this.$emit("change", changedFields);
      },
      mapPropsToFields: () => {
        return {
          workinghours: this.$form.createFormField({
            value: this.editinfo.workinghours
          })
        };
      },
      onValuesChange: (_, values) => {
        this.$logger.d("EditInfo", "onValuesChange", {
          values: values
        });
      }
    });
  },
  mounted() {
    this.loadData();
  },
  computed: {
    status: {
      get: function() {
        return this.statusex(this.editinfo.status)
      }
    },
    showTooltip: {
      get: function() {
        let editinfo = this.editinfo
        let needshow = editinfo.status && editinfo.status === 'rejected' && editinfo.comment && editinfo.comment.length > 0
        console.log(needshow);

        return needshow;
      }
    },
    staColor: {
      get: function() {
        return this.editinfo.status === "comitted" ? "gray" :
          this.editinfo.status === "confirmed" ? "green" : "red";
      }
    },
    disabledForm: {
      get: function() {
        return this.editinfo.status === "confirmed" ? true : false;
      }
    }
  },
  data() {
    return {
      isLoading: true,
      targetMonth: "",
      listdata: [],
      editinfo: {
        status: "",
        workinghours: "",
        comment: ""
      }
    };
  },
  methods: {
    onSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        this.$logger.d("TransExp", "onSubmit", {
          err: err,
          values: values
        });
        if (!err) {
          let token = this.$store.getters.token;
          let info = this.$store.getters.info;
          this.$api.workinghours
            .update({
              eid: info.eid,
              targmonth: this.targetMonth,
              workinghours: values.workinghours,
              token: token
            })
            .then(data => {
              let resp = data.data;
              this.$logger.d("WorkingHours", "onSubmit.update", {
                response: resp
              });
              if (resp.error) {
                // this.$notification.error({
                //   message: "エラー:" + resp.error.code,
                //   description: resp.error.description
                // });
                this.$error_handler(this,resp.error)
              } else {
                this.$notification.success({
                  message: "提出しました"
                });
                this.loadData();
              }
            })
            .catch(err => {
              this.$logger.e("WorkingHours", "api", {
                error: err
              });
              this.$notification.error({
                message: "エラー",
                description: "サーバ通信エラー"
              });
            });
        }
      });
    },
    statusex(status) {
      if (status === "comitted") {
        return "提出済";
      } else if (status === "confirmed") {
        return "承認済";
      } else if (status === "rejected") {
        return "拒否";
      } else {
        return "未提出"
      }
    },
    loadData() {
      this.isLoading = true;
      this.listdata = []
      let token = this.$store.getters.token;
      let info = this.$store.getters.info;
      this.$api.workinghours
        .query({
          eid: info.eid,
          token: token
        })
        .then(data => {
          let resp = data.data;
          this.$logger.d("WorkingHours", "loadData", {
            response: resp
          });
          if (resp.error) {
            // this.$notification.error({
            //   message: "エラー:" + resp.error.code,
            //   description: resp.error.description
            // });
            this.$error_handler(this,resp.error)
          } else {
            if (resp.result.workinghours.length > 0) {
              this.listdata = resp.result.workinghours
              this.listdata.sort((a, b) => {
                return this.$moment(a.targmonth).isAfter(b.targmonth) ? -1 : 1;
              }).forEach((el) => {
                el.statusex = this.statusex(el.status)
              })
              console.log("aa:" + JSON.stringify(this.listdata));
            } else {
              this.listdata = []
              // this.editinfo.status = "";
              // this.editinfo.comment = "";
              // this.editinfo.workinghours = "";
              // this.form.setFieldsValue({
              //   workinghours: this.editinfo.workinghours
              // });
            }
          }
          this.loadTargData(this.targetMonth)
          this.isLoading = false;
        })
        .catch(err => {
          this.$logger.e("WorkingHours", "api", {
            error: err
          });
          this.$notification.error({
            message: "エラー",
            description: "サーバ通信エラー"
          });
          this.isLoading = false;
        });
    },
    loadTargData(targetMonth) {
      let targdatas = this.listdata.filter(d => d.targmonth === targetMonth)
      if (targdatas.length > 0) {
        let targdata = targdatas[0]
        this.editinfo.status = targdata.status;
        this.editinfo.comment = targdata.comment;
        this.editinfo.workinghours = targdata.workinghours;
      } else {
        this.editinfo.status = "";
        this.editinfo.comment = "";
        this.editinfo.workinghours = "";
      }
      this.form.setFieldsValue({
        workinghours: this.editinfo.workinghours
      });
    },
    onTargetMonthChange(value) {
      console.log("onTargetMonthChange", value);
      this.targetMonth = value.format("YYYY/MM");
      this.loadTargData(this.targetMonth)
      // this.loadData();
    },
    disabledDate(current) {
      // can not select days before today and today
      return current && current.valueOf() > Date.now();
    }
  }
};
</script>
<style scoped>
.ant-form-item {
  margin: 0 0;
}
</style>
